import { render, staticRenderFns } from "./cascader.vue?vue&type=template&id=d610ed44&scoped=true&"
import script from "./cascader.vue?vue&type=script&lang=js&"
export * from "./cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d610ed44",
  null
  
)

export default component.exports